@if (isLoading) {
  <div class="reserve-loading-container">
    <div class="loading-container"></div>
    <span>載入問卷資料中．．．</span>
  </div>
} @else {
<div class="page-container">
  @if(questionnaireStatus === 'NOT_NEEDED'){
    <div class="reserve-available-content">
      <div class="page-title-block">
        <h2 class="page-title">您目前無需填寫問卷</h2>
        <p class="page-status-msg">您還沒預約健檢，或本次健檢已經完成，<br>因此目前不需要填寫問卷</p>
      </div>
    </div>
  } @else if (questionnaireStatus === 'WAITING') {
    <div class="reserve-available-content">
      <div class="page-title-block">
        <h2 class="page-title">問卷會在健檢前 7 天開放</h2>
        <p class="page-status-msg">您尚未進入問卷填寫期間，系統將在健檢前 7 天提醒您填寫</p>
      </div>
    </div>
  } @else if (questionnaireStatus === 'OVERDUE') {
    <div class="reserve-available-content">
      <div class="page-title-block">
        <h2 class="page-title">問卷填寫已截止</h2>
        <p class="page-status-msg">您的健檢預約已過期，問卷填寫期限已截止。<br> 若有需要，請先至「我的預約」重新安排健檢時間。</p>
      </div>
    </div>
  } @else {
    <div class="reserve-container">
  
    <!--步驟列表-->
    <div class="reserve-steps">
      <div class="reserve-steps-block" [ngClass]="{ 'active-step': step >= 1 }">
        <span class="reserve-steps-process"></span>
        <p class="reserve-steps-title">
          {{ 'health-questionnaire.personal-history' | translate }}
        </p>
      </div>
      <div class="reserve-steps-block" [ngClass]="{ 'active-step': step >= 2 }">
        <span class="reserve-steps-process"></span>
        <p class="reserve-steps-title">
          {{ 'health-questionnaire.family-history' | translate }}
        </p>
      </div>
      <div class="reserve-steps-block" [ngClass]="{ 'active-step': step >= 3 }">
        <span class="reserve-steps-process"></span>
        <p class="reserve-steps-title">
          {{ 'health-questionnaire.subjective-symptoms' | translate }}
        </p>
      </div>
      <div class="reserve-steps-block" [ngClass]="{ 'active-step': step >= 4 }">
        <span class="reserve-steps-process"></span>
        <p class="reserve-steps-title">
          {{ 'health-questionnaire.long-term-medication' | translate }}
        </p>
      </div>
      <div class="reserve-steps-block" [ngClass]="{ 'active-step': step >= 5 }">
        <span class="reserve-steps-process"></span>
        <p class="reserve-steps-title">
          {{ 'health-questionnaire.surgery-history-or-major-trauma' | translate }}
        </p>
      </div>
      <div class="reserve-steps-block" [ngClass]="{ 'active-step': step >= 6 }">
        <span class="reserve-steps-process"></span>
        <p class="reserve-steps-title">
          {{ 'health-questionnaire.lifestyle-habit' | translate }}
        </p>
      </div>
      <div class="reserve-steps-block" [ngClass]="{ 'active-step': step >= 7 }">
        <span class="reserve-steps-process"></span>
        <p class="reserve-steps-title">
          {{ 'health-questionnaire.occupational-history' | translate }}
        </p>
      </div>
      <div class="reserve-steps-block" [ngClass]="{ 'active-step': step >= 8 }">
        <span class="reserve-steps-process"></span>
        <p class="reserve-steps-title">
          {{ 'health-questionnaire.other-info' | translate }}
        </p>
      </div>
    </div>
  </div>

  <!--  <div class="card-content register-card-content">-->
  @if (step === 1) {
    <!--個人病史-->
    <div class="card-content register-card-content" [class.input-error]="showPersonalHistoryError">
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title">
          {{
            'health-questionnaire.do-you-have-following-personal-history'
              | translate
          }}
        </h3>
        <div class="input-block">
          <mat-checkbox
            [(ngModel)]="personalNoneOfFollowing"
            (change)="togglePersonalNoneOfFollowing()"
            >{{ 'health-questionnaire.none-of-following' | translate }}
          </mat-checkbox>
        </div>
      </div>
      <div
        [class.disabled]="personalNoneOfFollowing"
        class="questionnaire-content"
      >
        @for (
          diseaseGroup of personalQuestionnaire?.diseaseGroups;
          let i = $index;
          track i
        ) {
          <div class="input-block step-input-block">
            <label class="input-title">{{ diseaseGroup.diseaseType }}</label>
            <section class="mat-mdc-checkbox-group" [class.input-error]="showPersonalHistoryError">
              @for (
                diseaseOption of diseaseGroup.diseaseOptions;
                let j = $index;
                track j
              ) {
                <mat-checkbox
                  [disabled]="personalNoneOfFollowing"
                  [checked]="
                    personalDiseases.includes(
                      diseaseOption.name | personalHistoryDisease
                    ) || isPersonalDiseaseChecked(diseaseOption.choiceId)
                  "
                  (change)="
                    onPersonalDiseaseCheckboxChange(
                      $event.checked,
                      diseaseOption
                    )
                  "
                >
                  {{ diseaseOption.name }}
                </mat-checkbox>
                @if (diseaseOption.detailPlaceholder) {
                  <!-- 只在勾選該項目時才顯示 input -->
                  @if (isPersonalDiseaseChecked(diseaseOption.choiceId)) {
                    <div class="input-group" [id]="'personal-detail-' + diseaseOption.choiceId">
                      <input
                        matInput
                        [disabled]="personalNoneOfFollowing"
                        [placeholder]="diseaseOption.detailPlaceholder"
                        [(ngModel)]="personalDiseaseDetails[diseaseOption.choiceId]"
                        [ngClass]="{
                          'input-error':
                            showError &&
                            (!personalDiseaseDetails[diseaseOption.choiceId] ||
                            personalDiseaseDetails[diseaseOption.choiceId].trim() === '')
                        }"
                        (input)="onPersonalDiseaseDetailInput(diseaseOption, $event)"
                      />
                      @if (
                        showError &&
                        (!personalDiseaseDetails[diseaseOption.choiceId] ||
                        personalDiseaseDetails[diseaseOption.choiceId].trim() === '')
                      ) {
                        <mat-error class="input-error-msg">{{
                          'error.cannot-be-empty' | translate
                        }}</mat-error>
                      }
                    </div>
                  }
                }
              }
            </section>
          </div>
        }
      </div>
    </div>
  } @else if (step === 2) {
    <!--家族病史-->
    <div class="card-content register-card-content" [class.input-error]="showFamilyHistoryError">
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title">
          {{
            'health-questionnaire.do-you-have-following-family-history'
              | translate
          }}
        </h3>
        <div class="input-block">
          <mat-checkbox
            [(ngModel)]="familyNoneOfFollowing"
            (change)="toggleFamilyNoneOfFollowing()"
            >{{ 'health-questionnaire.none-of-following' | translate }}
          </mat-checkbox>
        </div>
      </div>
      <div
        [class.disabled]="familyNoneOfFollowing"
        class="questionnaire-content"
      >
        @for (
          diseaseGroup of familyQuestionnaire?.diseaseGroups;
          let i = $index;
          track i
        ) {
          <div class="input-block">
            <label class="input-title">{{ diseaseGroup.diseaseType }}</label>
            <section class="mat-mdc-checkbox-group" [class.input-error]="showFamilyHistoryError">
              @for (
                diseaseOption of diseaseGroup.diseaseOptions;
                let j = $index;
                track j
              ) {
                <mat-checkbox
                  [disabled]="familyNoneOfFollowing"
                  [checked]="
                    familyDiseases.includes(
                      diseaseOption.name | familyHistoryDisease
                    )
                  "
                  (change)="
                    onFamilyDiseaseChange($event.checked, diseaseOption)
                  "
                >
                  {{ diseaseOption.name }}
                </mat-checkbox>
              }
            </section>
          </div>
        }
        <div class="input-block">
          <label class="input-title">{{
            'health-questionnaire.other-family-disease' | translate
          }}</label>
          <input
            [disabled]="familyNoneOfFollowing"
            class="input-group"
            matInput
            [placeholder]="
              'health-questionnaire.example-placeholder' | translate
            "
            [(ngModel)]="otherFamilyDisease"
            (input)="onOtherFamilyDiseaseInput($event)"
          />
        </div>
      </div>
    </div>
  } @else if (step === 3) {
    <!--自覺症狀-->
    <div class="card-content register-card-content" [class.input-error]="showSubjectiveSymptomError">
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title">
          {{
            'health-questionnaire.do-you-have-following-subjective-symptoms'
              | translate
          }}
        </h3>
        <div class="input-block">
          <mat-checkbox
            [(ngModel)]="subjectiveSymptomNoneOfFollowing"
            (change)="toggleSubjectiveSymptomNoneOfFollowing()"
            >{{ 'health-questionnaire.none-of-following' | translate }}
          </mat-checkbox>
        </div>
      </div>

      <div
        [class.disabled]="subjectiveSymptomNoneOfFollowing"
        class="questionnaire-content"
      >
        @for (
          diseaseGroup of subjectiveSymptomQuestionnaire?.diseaseGroups;
          let i = $index;
          track i
        ) {
          <div class="input-block">
            <label class="input-title">{{ diseaseGroup.diseaseType }}</label>
            <section class="mat-mdc-checkbox-group" [class.input-error]="showSubjectiveSymptomError">
              @for (
                diseaseOption of diseaseGroup.diseaseOptions;
                let j = $index;
                track j
              ) {
                <mat-checkbox
                  [disabled]="subjectiveSymptomNoneOfFollowing"
                  [checked]="
                    subjectiveSymptomDiseases.includes(
                      diseaseOption.name | subjectiveSymptomDisease
                    )
                  "
                  (change)="
                    onSubjectiveSymptomDiseaseChange(
                      $event.checked,
                      diseaseOption
                    )
                  "
                >
                  {{ diseaseOption.name }}
                </mat-checkbox>
              }
            </section>
          </div>
        }
        <div class="input-block">
          <label class="input-title">{{
            'health-questionnaire.other-subjective-symptoms' | translate
          }}</label>
          <input
            [disabled]="subjectiveSymptomNoneOfFollowing"
            class="input-group"
            matInput
            [placeholder]="
              'health-questionnaire.subjective-symptoms-placeholder' | translate
            "
            [(ngModel)]="otherSubjectiveSymptomDisease"
            (input)="onOtherSubjectiveSymptomInput($event)"
          />
        </div>
      </div>
    </div>
  } @else if (step === 4) {
    <!--長期服用藥物-->
    <div class="card-content register-card-content" [class.input-error]="showLongTermMedicationError">
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title">
          {{
            'health-questionnaire.do-you-have-following-long-term-medication'
              | translate
          }}
        </h3>
        <div class="input-block">
          <mat-checkbox
            [(ngModel)]="longTermMedicationNoneOfFollowing"
            (change)="toggleLongTermMedicationNoneOfFollowing()"
            >{{ 'health-questionnaire.none-of-following' | translate }}
          </mat-checkbox>
        </div>
      </div>

      <div
        [class.disabled]="longTermMedicationNoneOfFollowing"
        class="questionnaire-content"
      >
        @for (
          diseaseGroup of longTermMedicationQuestionnaire?.diseaseGroups;
          let i = $index;
          track i
        ) {
          <div class="input-block">
            <section class="mat-mdc-checkbox-group" [class.input-error]="showLongTermMedicationError">
              @for (
                diseaseOption of diseaseGroup.diseaseOptions;
                let j = $index;
                track j
              ) {
                <mat-checkbox
                  [disabled]="longTermMedicationNoneOfFollowing"
                  [checked]="longTermMedications.includes(diseaseOption.name)"
                  (change)="
                    onLongTermMedicationChange($event.checked, diseaseOption)
                  "
                >
                  {{ diseaseOption.name }}
                </mat-checkbox>
              }
            </section>
          </div>
        }
        <div class="input-block">
          <label class="input-title">{{
            'health-questionnaire.other-long-term-medication' | translate
          }}</label>
          <input
            [disabled]="longTermMedicationNoneOfFollowing"
            class="input-group"
            matInput
            [placeholder]="
              'health-questionnaire.long-term-medication-placeholder' | translate
            "
            [(ngModel)]="otherLongTermMedication"
            (input)="onOtherLongTermMedicationInput($event)"
            [ngClass]="{
              'input-error': showLongTermMedicationError && 
                            !longTermMedicationNoneOfFollowing && 
                            longTermMedications.length === 0 && 
                            (!otherLongTermMedication || !otherLongTermMedication.trim())
            }"
          />
          @if (showLongTermMedicationError && 
              !longTermMedicationNoneOfFollowing && 
              longTermMedications.length === 0 && 
              (!otherLongTermMedication || !otherLongTermMedication.trim())) {
            <mat-error class="input-error-msg">{{
              'error.cannot-be-empty' | translate
            }}</mat-error>
          }
        </div>
      </div>
    </div>
  } @else if (step === 5) {
    <!--手術史或重大外傷-->
    <div class="card-content register-card-content member-card-content">
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title">
          {{
            'health-questionnaire.do-you-have-following-surgery-history-or-major-trauma'
              | translate
          }}
        </h3>
        <div class="input-block">
          <mat-radio-group
            [(ngModel)]="hasSurgeryHistoryOrMajorTrauma"
            (change)="toggleHasSurgeryHistoryOrMajorTrauma()"
          >
            <mat-radio-button [value]="API_PARAMS.YES">{{
              'common.radio-button.yes' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="API_PARAMS.NO">{{
              'common.radio-button.no' | translate
            }}</mat-radio-button>
          </mat-radio-group>
        </div>
        @if (hasSurgeryHistoryOrMajorTrauma === API_PARAMS.YES) {
          <div class="input-block">
            <label class="input-title">{{
              'health-questionnaire.enter-surgery-history-or-major-trauma'
                | translate
            }}</label>
            <input
              class="input-group"
              matInput
              [placeholder]="
                'health-questionnaire.surgery-history-or-major-trauma-placeholder'
                  | translate
              "
              (input)="onInputHasSurgeryHistoryOrMajorTrauma()"
              [(ngModel)]="surgeryHistoryOrMajorTrauma"
              [ngClass]="{
                'input-error': showError && hasSurgeryHistoryOrMajorTrauma === API_PARAMS.YES && (!surgeryHistoryOrMajorTrauma || !surgeryHistoryOrMajorTrauma.trim())
              }"
            />
            @if (showError && hasSurgeryHistoryOrMajorTrauma === API_PARAMS.YES && (!surgeryHistoryOrMajorTrauma || !surgeryHistoryOrMajorTrauma.trim())) {
              <mat-error class="input-error-msg">{{
                'error.cannot-be-empty' | translate
              }}</mat-error>
            }
          </div>
        }
      </div>
    </div>
  } @else if (step === 6) {
    <!--生活習慣-->
  <div class="card-content register-card-content member-card-content">
    <div class="register-card-title-questionnaire">
      <h3 class="register-card-title">
        {{ 'health-questionnaire.lifestyle-habit' | translate }}
      </h3>
      @if (showError && (!isLifeStyleRadioValid() || !isLifeStyleCheckboxValid() || !isLifeStyleNumberInputValid())) {
        <mat-error class="input-error-msg" style="color: red; margin-top: -20px; display: block;">
          請完成所有必填項目後再繼續
        </mat-error>
      }
    </div>
    <div class="questionnaire-content life-block">
      @for (
        diseaseGroup of lifeStyleHabitQuestionnaire?.diseaseGroups;
        let i = $index;
        track i
      ) {
        <div class="input-block">
          <label class="input-title">{{ diseaseGroup.diseaseType }}</label>
          <section class="mat-mdc-checkbox-group">
            @if (i < 3) {
              <mat-radio-group 
                [(ngModel)]="selectedLifeStyleHabits[i]"
                [class.input-error]="showError && lifeStyleErrors[i]">
                @for (
                  diseaseOption of diseaseGroup.diseaseOptions;
                  let j = $index;
                  track j
                ) {
                  <mat-radio-button
                    [value]="diseaseOption.name"
                    (change)="
                      onLifeHabitRadioChange(
                        diseaseGroup.diseaseType,
                        diseaseOption,
                        i
                      )
                    "
                    >{{ diseaseOption.name }}
                  </mat-radio-button>
                }
              </mat-radio-group>

              <!-- 檳榔、抽菸、喝酒的詳細輸入保持不變 -->
              @if (diseaseGroup.diseaseType === '最近六個月內是否有嚼食檳榔') {
                @if (selectedLifeStyleHabits[i] === '幾乎每天嚼') {
                  <div class="input-group input-time-block">
                    <span>每天嚼</span>
                    <input type="number" class="input-time-field" [formControl]="betelNutPerDay" min="0" step="1" [class.input-error]="showError && betelNutPerDay.invalid"/>
                    <span>顆，已經嚼食</span>
                    <input type="number" class="input-time-field" [formControl]="betelNutYears" min="0" step="1" [class.input-error]="showError && betelNutYears.invalid"/>
                    <span>年</span>
                    <input type="number" class="input-time-field" [formControl]="betelNutMonths" min="0" max="12" step="1" [class.input-error]="showError && betelNutMonths.invalid"/>
                    <span>個月</span>
                  </div>
                } @else if (selectedLifeStyleHabits[i] === '已經戒食') {
                  <div class="input-group input-time-block">
                    <span>已經戒食，戒了</span>
                    <input type="number" class="input-time-field" [formControl]="betelNutQuitYears" min="0" step="1" [class.input-error]="showError && betelNutQuitYears.invalid"/>
                    <span>年</span>
                    <input type="number" class="input-time-field" [formControl]="betelNutQuitMonths" min="0" max="12" step="1" [class.input-error]="showError && betelNutQuitMonths.invalid"/>
                    <span>個月</span>
                  </div>
                }
              }
              
              @if (diseaseGroup.diseaseType === '過去一個月內是否有吸菸') {
                @if (selectedLifeStyleHabits[i] === '(幾乎)每天吸') {
                  <div class="input-group input-time-block">
                    <span>平均每天吸</span>
                    <input type="number" class="input-time-field" [formControl]="cigarettesPerDay" min="0" step="1" [class.input-error]="showError && cigarettesPerDay.invalid"/>
                    <span>支，已吸</span>
                    <input type="number" class="input-time-field" [formControl]="smokingYears" min="0" step="1" [class.input-error]="showError && smokingYears.invalid"/>
                    <span>年</span>
                  </div>
                } @else if (selectedLifeStyleHabits[i] === '已經戒菸') {
                  <div class="input-group input-time-block">
                    <span>已經戒菸，戒了</span>
                    <input type="number" class="input-time-field" [formControl]="smokingQuitYears" min="0" step="1" [class.input-error]="showError && smokingQuitYears.invalid"/>
                    <span>年</span>
                    <input type="number" class="input-time-field" [formControl]="smokingQuitMonths" min="0" max="12" step="1" [class.input-error]="showError && smokingQuitMonths.invalid"/>
                    <span>個月</span>
                  </div>
                }
              }

              @if (diseaseGroup.diseaseType === '過去一個月內是否有喝酒') {
                @if (selectedLifeStyleHabits[i] === '(幾乎)每天喝') {
                  <div class="input-group input-time-block">
                    <span>平均每週喝</span>
                    <input type="number" class="input-time-field" [formControl]="alcoholTimesPerWeek" min="0" step="1" [class.input-error]="showError && alcoholTimesPerWeek.invalid"/>
                    <span>次，最常喝</span>
                    <input type="text" class="input-time-field" [formControl]="alcoholType" [class.input-error]="showError && (!alcoholType.value || !alcoholType.value.trim())"/>
                    <span>酒，每次</span>
                    <input type="number" class="input-time-field" [formControl]="alcoholAmountCc" min="0" step="1" [class.input-error]="showError && alcoholAmountCc.invalid"/>
                    <span>cc</span>
                  </div>
                } @else if (selectedLifeStyleHabits[i] === '已經戒酒') {
                  <div class="input-group input-time-block">
                    <span>已經戒酒，戒了</span>
                    <input type="number" class="input-time-field" [formControl]="alcoholQuitYears" min="0" step="1" [class.input-error]="showError && alcoholQuitYears.invalid"/>
                    <span>年</span>
                    <input type="number" class="input-time-field" [formControl]="alcoholQuitMonths" min="0" max="12" step="1" [class.input-error]="showError && alcoholQuitMonths.invalid"/>
                    <span>個月</span>
                  </div>
                }
              }
            } @else {
              @for (
                diseaseOption of diseaseGroup.diseaseOptions;
                let j = $index;
                track j
              ) {
                <mat-checkbox
                  [checked]="
                    lifeStyleHabits.includes(
                      diseaseGroup.diseaseType + '_' + diseaseOption.name
                    )
                  "
                  [disabled]="diseaseOption.name !== '以下皆無' && isDietHabitNone()"
                  (change)="
                    onLifeHabitChange(
                      diseaseGroup.diseaseType,
                      $event.checked,
                      diseaseOption
                    )
                  "
                  [class.input-error]="showError && lifeStyleErrors[i]">
                  {{ diseaseOption.name }}
                </mat-checkbox>
              }
            }
          </section>
        </div>
        <hr />
      }
    </div>
  </div>

    <!--運動習慣-->
  <div class="card-content register-card-content member-card-content">
    <div class="register-card-title-questionnaire">
      <h3 class="register-card-title">
        {{ 'health-questionnaire.exercise-habit' | translate }}
      </h3>
      @if (showError && (!isExerciseRadioValid() || !isExerciseCheckboxValid())) {
        <mat-error class="input-error-msg" style="color: red; margin-top: -20px; display: block;">
          請完成所有必填項目後再繼續
        </mat-error>
      }
    </div>
    <div class="questionnaire-content">
      @for (
        diseaseGroup of exerciseHabitQuestionnaire?.diseaseGroups;
        let i = $index;
        track i
      ) {
        <div class="input-block">
          <label
            class="input-title"
            [class.disabled]="i !== 0 && !isExerciseQuestionEnabled(i)"
            >{{ i + 1 }} . {{ diseaseGroup.diseaseType }}</label
          >
          <section class="mat-mdc-checkbox-group">
            @if (i == 0) {
              <mat-radio-group
                [(ngModel)]="hasExerciseHabit"
                (change)="onHashExerciseHabitChange()"
                [class.input-error]="showError && exerciseHabitErrors[i]"
              >
                @for (
                  diseaseOption of diseaseGroup.diseaseOptions;
                  let j = $index;
                  track j
                ) {
                  <mat-radio-button
                    [value]="j === 0 ? API_PARAMS.NO : API_PARAMS.YES"
                    >{{ diseaseOption.name }}
                  </mat-radio-button>
                }
              </mat-radio-group>
            } @else if (i !== 3 && i !== 5) {
              <!-- 運動禁忌使用 checkbox（可複選） -->
              @if (i === 4) {
                @for (
                  diseaseOption of diseaseGroup.diseaseOptions;
                  let j = $index;
                  track j
                ) {
                  <mat-checkbox
                    [checked]="exerciseHabits.includes(diseaseGroup.diseaseType + '_' + diseaseOption.name)"
                    [disabled]="!isExerciseQuestionEnabled(i) || (diseaseOption.name !== '無' && isExerciseProhibitionNone())"
                    (change)="
                      onExerciseHabitChange(
                        diseaseGroup.diseaseType,
                        $event.checked,
                        diseaseOption
                      )
                    "
                    [class.input-error]="showError && isExerciseQuestionEnabled(i) && exerciseHabitErrors[i]"
                    >{{ diseaseOption.name }}
                  </mat-checkbox>
                }
              } @else {
                <!-- 其他問題使用 radio button（單選） -->
                <mat-radio-group
                  [(ngModel)]="selectedExerciseHabits[i]"
                  [disabled]="!isExerciseQuestionEnabled(i)"
                  [class.input-error]="showError && isExerciseQuestionEnabled(i) && exerciseHabitErrors[i]"
                >
                  @for (
                    diseaseOption of diseaseGroup.diseaseOptions;
                    let j = $index;
                    track j
                  ) {
                    <mat-radio-button
                      [value]="diseaseOption.name"
                      (change)="
                        onExerciseHabitRadioChange(
                          diseaseGroup.diseaseType,
                          diseaseOption,
                          i
                        )
                      "
                      >{{ diseaseOption.name }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              }
            } @else {
              @for (
                diseaseOption of diseaseGroup.diseaseOptions;
                let j = $index;
                track j
              ) {
                <mat-checkbox
                  [disabled]="!isExerciseQuestionEnabled(i)"
                  [checked]="
                    exerciseHabits.includes(
                      diseaseGroup.diseaseType + '_' + diseaseOption.name
                    )
                  "
                  (change)="
                    onExerciseHabitChange(
                      diseaseGroup.diseaseType,
                      $event.checked,
                      diseaseOption
                    )
                  "
                  [class.input-error]="showError && isExerciseQuestionEnabled(i) && exerciseHabitErrors[i]"
                >
                  {{ diseaseOption.name }}
                </mat-checkbox>
              }
            }
            
            <!-- 運動禁忌的詳細選項保持不變 -->
            @if (diseaseGroup.diseaseType === '運動禁忌') {
              @if (selectedExerciseHabits[i] === '有') {
                <mat-checkbox>上肢</mat-checkbox>
                <mat-checkbox>脊椎、背部</mat-checkbox>
                <mat-checkbox>下肢</mat-checkbox>
              }
            }
          </section>
        </div>
      }
    </div>
  </div>
  } @else if (step === 7) {
    <!--作業經歷-->
    <!--目前職業-->
    <form
      [formGroup]="occupation"
      class="card-content register-card-content member-card-content"
    >
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title no-required">
          {{ 'health-questionnaire.current-occupation' | translate }}
        </h3>
      </div>
      <div class="questionnaire-content">
        <div class="input-block">
          <label class="input-title">{{
            'health-questionnaire.occupation-category' | translate
          }}</label>
          <mat-form-field appearance="fill" class="input-group">
            <mat-select formControlName="category">
              <mat-option value="">{{
                'health-questionnaire.occupation-category-placeholder'
                  | translate
              }}</mat-option>
              @for (category of CURRENT_OCCUPATION_CATEGORY_OPTIONS; track $index) {
                <mat-option [value]="category.answer">{{
                  category.name | translate
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (occupation.value.category === '19') {
          <div class="input-block">
            <label class="input-title">{{
              'health-questionnaire.other-occupation' | translate
            }}</label>
            <div class="input-group">
              <input
                matInput
                type="text"
                formControlName="otherOccupation"
                [placeholder]="
                  'health-questionnaire.other-occupation-placeholder' | translate
                "
                (input)="markFormDirty()"
              />
            </div>
          </div>
        }
        <hr />
        <div class="input-block">
          <label class="input-title">{{
            'health-questionnaire.employment-date' | translate
          }}</label>
          <div class="input-calculator-block">
            <div class="input-group input-btn-right">
              <input
                id="employement-date"
                matInput
                [matDatepicker]="picker"
                [placeholder]="
                  'health-questionnaire.employment-date-placeholder' | translate
                "
                formControlName="employmentDate"
              />
              <mat-datepicker-toggle [for]="picker" class="input-date-btn">
                <ng-container matDatepickerToggleIcon>
                  <img src="assets/img/i-calendar.svg" alt="" />
                </ng-container>
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </div>
          </div>
        </div>
        <hr />
        <!-- 是否需輪班 + 輪班制 -->
        <div class="input-block">
          <label class="input-title">{{
            'health-questionnaire.occupation-type' | translate
          }}</label>
          <mat-radio-group formControlName="type" (change)="onShiftTypeChange()">
            <!-- 是否需輪班：否 -->
            @for (option of NEEDS_SHIFT_OPTIONS; track $index) {
              @if (option.answer === '1') {
                <mat-radio-button value="needs_shift_no">{{
                  option.name
                }}</mat-radio-button>
              }
            }
            <!-- 輪班制：兩班制/三班制/四班制/其他 -->
            @for (option of SHIFT_TYPE_OPTIONS; track $index) {
              <mat-radio-button [value]="'shift_type_' + option.answer">{{
                option.name
              }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>

        <!-- 輪班方式說明 - 只在選擇「其他」時顯示 -->
        @if (occupation.value.type === 'shift_type_4') {
          <div class="input-block">
            <label class="input-title">{{
              'health-questionnaire.other-shifts' | translate
            }}</label>
            <div class="input-group">
              <input
                matInput
                type="text"
                formControlName="shiftDescription"
                [placeholder]="
                  'health-questionnaire.other-shift-placeholder' | translate
                "
                (input)="markFormDirty()"
              />
            </div>
          </div>
        }
      </div>
    </form>

    <!--過去職業-->
    <form
      [formGroup]="previousOccupation"
      class="card-content register-card-content member-card-content"
    >
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title no-required">
          {{ 'health-questionnaire.former-occupation' | translate }}
        </h3>
      </div>
      <div class="input-block">
        <label class="input-title">{{
          'health-questionnaire.occupation-category' | translate
        }}</label>
        <mat-form-field appearance="fill" class="input-group">
          <mat-select formControlName="category">
            <mat-option value="">{{
              'health-questionnaire.occupation-category-placeholder' | translate
            }}</mat-option>
            @for (category of PREVIOUS_OCCUPATION_CATEGORY_OPTIONS; track $index) {
              <mat-option [value]="category.answer">{{
                category.name | translate
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (previousOccupation.value.category === '19') {
          <div class="input-block">
            <label class="input-title">{{
              'health-questionnaire.other-occupation' | translate
            }}</label>
            <div class="input-group">
              <input
                matInput
                type="text"
                formControlName="otherOccupation"
                [placeholder]="
                  'health-questionnaire.other-occupation-placeholder' | translate
                "
                (input)="markFormDirty()"
              />
            </div>
          </div>
        }
      <hr />
      <div class="input-block input-date-block">
        <div class="input-group">
          <label class="input-title">{{
            'health-questionnaire.start-date' | translate
          }}</label>
          <div class="input-date-group">
            <mat-form-field appearance="fill" class="input-date-field">
              <mat-select formControlName="startYear">
                <mat-option value="">{{
                  'health-questionnaire.please-select' | translate
                }}</mat-option>
                @for (year of years; track $index) {
                  <mat-option [value]="year">{{ year }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span>{{ 'health-questionnaire.year' | translate }}</span>
            <mat-form-field appearance="fill" class="input-date-field">
              <mat-select formControlName="startMonth">
                <mat-option value="">{{
                  'health-questionnaire.please-select' | translate
                }}</mat-option>
                @for (month of months; track $index) {
                  <mat-option [value]="month">{{ month }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span>{{ 'health-questionnaire.month' | translate }}</span>
          </div>
        </div>
        <div class="input-group">
          <label class="input-title">{{
            'health-questionnaire.end-date' | translate
          }}</label>
          <div class="input-date-group">
            <mat-form-field appearance="fill" class="input-date-field">
              <mat-select formControlName="endYear">
                <mat-option value="">{{
                  'health-questionnaire.please-select' | translate
                }}</mat-option>
                @for (year of years; track $index) {
                  <mat-option [value]="year">{{ year }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span>{{ 'health-questionnaire.year' | translate }}</span>
            <mat-form-field appearance="fill" class="input-date-field">
              <mat-select formControlName="endMonth">
                <mat-option value="">{{
                  'health-questionnaire.please-select' | translate
                }}</mat-option>
                @for (month of months; track $index) {
                  <mat-option [value]="month">{{ month }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span>{{ 'health-questionnaire.month' | translate }}</span>
          </div>
        </div>
      </div>
      <hr />
      <div class="input-block input-time-block">
        <label class="input-title">{{
          'health-questionnaire.avg-weekly-working-hours-past-month' | translate
        }}</label>
        <div class="input-group">
          <input
            class="input-time-field"
            matInput
            type="number"
            formControlName="avgWorkHoursPastMonth"
            min="0"
            [placeholder]="'health-questionnaire.select-hours' | translate"
            [class.input-error]="showError && 
              previousOccupation.get('avgWorkHoursPastMonth')?.value != null && 
              previousOccupation.get('avgWorkHoursPastMonth')?.value != 0 && 
              previousOccupation.get('avgWorkHoursPastMonth')?.invalid"
          />
          <span>{{ 'health-questionnaire.hours' | translate }}</span>
        </div>
      </div>
      <hr />
      <div class="input-block input-time-block">
        <label class="input-title">{{
          'health-questionnaire.avg-weekly-working-hours-past-six-months'
            | translate
        }}</label>
        <div class="input-group">
          <input
            class="input-time-field"
            matInput
            type="number"
            formControlName="avgWorkHoursPastSixMonths"
            min="0"
            [placeholder]="'health-questionnaire.select-hours' | translate"
            [class.input-error]="showError && 
              previousOccupation.get('avgWorkHoursPastSixMonths')?.value != null && 
              previousOccupation.get('avgWorkHoursPastSixMonths')?.value != 0 && 
              previousOccupation.get('avgWorkHoursPastSixMonths')?.invalid"
          />
          <span>{{ 'health-questionnaire.hours' | translate }}</span>
        </div>
      </div>
      <hr />
      <div class="input-block input-time-block">
        <label class="input-title">{{
          'health-questionnaire.avg-sleep-time-during-workdays' | translate
        }}</label>
        <div class="input-group">
          <input
            class="input-time-field"
            matInput
            type="number"
            formControlName="avgSleepTime"
            min="0"
            [placeholder]="'health-questionnaire.select-hours' | translate"
            [class.input-error]="showError && 
              previousOccupation.get('avgSleepTime')?.value != null && 
              previousOccupation.get('avgSleepTime')?.value != 0 && 
              previousOccupation.get('avgSleepTime')?.invalid"
          />
          <span>{{ 'health-questionnaire.hours' | translate }}</span>
        </div>
      </div>
      <hr />
      <div class="input-block">
        <label class="input-title">{{
          'health-questionnaire.exam-reason' | translate
        }}</label>
        <mat-radio-group formControlName="examReason">
          @for (reason of EXAM_REASON_OPTIONS; track $index) {
            <mat-radio-button [value]="reason.answer">{{
              reason.name
            }}</mat-radio-button>
          }
        </mat-radio-group>
      </div>
    </form>
  } @else if (step === 8) {
    <div class="card-content register-card-content member-card-content">
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title">
          {{ 'health-questionnaire.other-info' | translate }}
        </h3>
        @if (showError && (showResidenceCountryError || showMaritalStatusError || showEducationLevelError || showPositionError)) {
          <mat-error class="input-error-msg" style="color: red; margin-top: -20px; display: block;">
            請完成所有必填項目後再繼續
          </mat-error>
        }
      </div>
      <div class="questionnaire-content">
        <!-- 常住國家 -->
        <div class="input-block">
          <label class="input-title">{{
            'health-questionnaire.residence-country' | translate
          }}</label>
          <section class="mat-mdc-checkbox-group"
                   [class.input-error]="showResidenceCountryError">
            @for (country of RESIDENCE_COUNTRY_OPTIONS; track $index) {
              <mat-checkbox
                [checked]="residenceCountries.includes(country.answer)"
                (change)="onResidenceCountryChange($event.checked, country.answer)"
              >
                {{ country.name }}
              </mat-checkbox>
            }
          </section>

          <!-- 其他國家輸入框 -->
          @if (residenceCountries.includes('6')) {
            <div class="input-group">
              <input
                matInput
                type="text"
                [(ngModel)]="otherResidenceCountry"
                (input)="onOtherResidenceInputChange($event)"
                [placeholder]="'health-questionnaire.residence-country-placeholder' | translate"
                [ngClass]="{
                  'input-error': showResidenceCountryError && residenceCountries.includes('6') && (!otherResidenceCountry || !otherResidenceCountry.trim())
                }"
              />
              @if (showResidenceCountryError && residenceCountries.includes('6') && (!otherResidenceCountry || !otherResidenceCountry.trim())) {
                <mat-error class="input-error-msg">{{
                  'error.cannot-be-empty' | translate
                }}</mat-error>
              }
            </div>
          }
        </div>
        <hr />
        
        <!-- 婚姻狀況 -->
        <div class="input-block">
          <label class="input-title">{{
            'health-questionnaire.marital-status' | translate
          }}</label>
          <mat-radio-group
            [(ngModel)]="maritalStatus"
            (change)="onMaritalStatusChange()"
            [class.input-error]="showMaritalStatusError">
            @for (status of MARITAL_STATUS_OPTIONS; track $index) {
              <mat-radio-button [value]="status.answer">{{
                status.name
              }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>

        <!-- 教育程度 -->
        <div class="input-block">
          <label class="input-title">{{
            'health-questionnaire.education-level' | translate
          }}</label>
          <mat-radio-group
            [(ngModel)]="educationLevel"
            (change)="onEducationLevelChange()"
            [class.input-error]="showEducationLevelError">
            @for (level of EDUCATION_LEVEL_OPTIONS; track $index) {
              <mat-radio-button [value]="level.answer">{{
                level.name
              }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>

        <hr />

        <!-- 職位 -->
        <div class="input-block input-position-block">
          <label class="input-title">{{
            'health-questionnaire.position' | translate
          }}</label>
          <section class="mat-mdc-checkbox-group">
            <mat-radio-group
              [(ngModel)]="position"
              (change)="onPositionChange()"
              [class.input-error]="showPositionError">
              @for (position of POSITION_OPTIONS; track $index) {
                <mat-radio-button [value]="position.answer">{{
                  position.name
                }}</mat-radio-button>
              }
            </mat-radio-group>

            <!-- 其他職位輸入框 -->
            @if (position === '9') {
              <div class="input-group">
                <input
                  matInput
                  type="text"
                  [(ngModel)]="otherPosition"
                  (input)="onOtherPositionInputChange($event)"
                  [placeholder]="'health-questionnaire.other-position-placeholder' | translate"
                  [ngClass]="{
                    'input-error': showPositionError && position === '9' && (!otherPosition || !otherPosition.trim())
                  }"
                />
                @if (showPositionError && position === '9' && (!otherPosition || !otherPosition.trim())) {
                  <mat-error class="input-error-msg">{{
                    'error.cannot-be-empty' | translate
                  }}</mat-error>
                }
              </div>
            }
          </section>
        </div>
      </div>
    </div>
  }
  <div class="member-btn-block">
    @if (step !== 1) {
      <button
        mat-button
        (click)="previous()"
        class="btn-outline-primary btn-size-l"
      >
        {{ 'common.button.previous' | translate }}
      </button>
    }
    @if (step === 8) {
      <button mat-button (click)="save()" class="btn-fill-primary btn-size-l">
        {{ 'common.button.save' | translate }}
      </button>
    } @else {
      <button
        mat-button
        (click)="next($event)"
        class="btn-fill-primary btn-size-l"
      >
        {{ 'common.button.next' | translate }}
      </button>
    }
  </div>
}
  
</div>
}
